import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import Button from "@mui/material/Button";
import { defaultVehicleFixture } from "fixtures";
import "styles/common.scss";

type Props = {
    append: any;
};

const AddAnotherVehicle = ({ append }: Props) => {
    return (
        <Button
            onClick={() => append(defaultVehicleFixture)}
            className="common-fullwidth-button"
            disabled={localStorage.getItem("is_submit") === "true"}
            style={{ marginBottom: "1rem" }}
            data-testid="add-another-vehicle-button"
        >
            <AddCircleOutlineRoundedIcon fontSize="small" className="AddEquipmentIcon" />
            <span>Add Another Vehicle</span>
        </Button>
    );
};

export default AddAnotherVehicle;
